<script>
import { ref, reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import SvgIcon from '@/components/SvgIcon'
import SrUpload from '@/components/SrUpload'
import { routeTo } from "@/utils"
import { submitCompKycInfo, getIndividualMaterial } from "@/api/modules/auth"
import ResetAuthTypeDialog from '@/components/ResetAuthTypeDialog'
import RegStatus from '../company-auth/components/reg-status'
import { vab } from "@libs/utils"
import auth from "@/compositions/modules/auth"
import { useI18n } from "@/plugins/i18n"

export default {
  components: { SvgIcon, SrUpload, RegStatus, ResetAuthTypeDialog },
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const { FILE } = store.state.base.constant
    const stepComplete = computed(() => +store.state.auth.registerInfo.stepComplete)
    const kycReviewStatus = computed(() => store.state.auth.registerInfo.kycReviewStatus)
    const { formReq, loadingScope, userTypeEnum, idTypeEnum, judgeRejStatus } = initForm()
    
    const compRegRegionEnum = store.state.base.dict.country.map

    const handleUpdateStep = (step) => {
      switch (step) {
        case 'personRegInfoRsp' :
          routeTo('/auth/personal/register')
          break
        case 'businessInfoRsp' :
          routeTo('/auth/personal/businessInfo')
          break
        default :
          break
      }
    }

    const handleEditable = () => ((kycReviewStatus.value && ['WC', 'RJ'].includes(kycReviewStatus.value)) || !kycReviewStatus.value)

    // 显示提交按钮
    const handleShowOperation = auth.handleShowOperation

    const handleSubmitAll = async () => {
      if (!handleShowOperation()) return routeTo('/dashboard')
      loadingScope.btnLoading = true
      try {
        // await store.dispatch('user/getRegisterInfo')
        const params = {}
        await submitCompKycInfo(params)
        vab.baseMessage('提交成功', 'success')
        routeTo('/dashboard')
        loadingScope.btnLoading = false
      } catch (err) {
        loadingScope.btnLoading = false
        console.log(err)
      }
    }

    return {
      FILE,
      formReq,
      loadingScope,
      idTypeEnum,
      stepComplete,
      userTypeEnum,
      compRegRegionEnum,
      t,
      ...toRefs(initDialog()),
      handleUpdateStep,
      judgeRejStatus,
      handleShowOperation,
      handleEditable,
      handleSubmitAll
    }
  }
}

// 处理Form
const initForm = () => {
  const store = useStore()
  const { t } = useI18n()
  const formReq = reactive({
    businessInfoRsp: {
      employmentInfo: "",
      otherMaterialFileId: "",
      recoCustomerInfo: "",
      regId: "",
    },
    personRegInfoRsp: {
      backFileId: "",
      frontFileId: "",
      holdFileId: "",
      regAddress: "",
      regCheckStatus: "",
      regEAddress: "",
      regEname: "",
      regId: "",
      regName: "",
      regRejectRemark: "",
    },
  })

  const userTypeEnum = {
    L: t('auth.company.register.label.text_2'),
    A: t('auth.company.register.label.text_3'),
  }

  const idTypeEnum = {
    I: t('auth.company.info.content.text_15_2'),
    P: t('auth.company.info.content.text_15'),
    H: t('auth.company.info.content.text_15_4')
  }

  const judgeRejStatus = () => {
    return ['RJ', 'RC', 'ST'].includes(formReq.personRegInfoRsp.regCheckStatus)
  }

  const loadingScope = reactive({
    pageLoading: false,
    btnLoading: false
  })

  const initData = async () => {
    loadingScope.pageLoading = true
    try {
      const res = await getIndividualMaterial()
      store.dispatch('auth/setStep', res.step)

      formReq.businessInfoRsp = res.businessInfoRsp
      formReq.personRegInfoRsp = res.personRegInfoRsp

      loadingScope.pageLoading = false
    } catch {
      loadingScope.pageLoading = false
    }
  }

  initData()

  return { formReq, loadingScope, userTypeEnum, idTypeEnum, judgeRejStatus }
}

// 处理弹框
const initDialog = () => {
  const dialogVisible = ref(false)
  return { dialogVisible }
}
</script>

<template>
  <div class="company-auth-overview-container">
    <el-row>
      <div class="block-one">
        <div class="h0">{{t('auth.personal.overview.title.text_2')}}</div>
        <div class="a" style="font-size: 16px;margin-right: 6px;" v-if="handleShowOperation()" @click="dialogVisible = true">{{t('auth.personal.register.content.text_7')}}<svg-icon icon-class="问号"/></div>
      </div>
      <div class="reject-wrap" v-if="judgeRejStatus()">
        <svg-icon icon-class="红色叹号" class-name="icon"/>
        <div style="margin-left: 14px;">{{t('dashboard.bank.content.text_4')}}</div>
        <div style="margin-left: 78px;">{{t('auth.company.overview.content.text_3')}}</div>
      </div>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form :model="formReq" :label-width="localCN?'150px':'230px'" label-position="left">
          <!--注册人信息-->
          <div class="form-operation-wrap">
            <div class="title">{{t('auth.personal.register.title.text_1')}}</div>
            <div class="btn" v-if="handleShowOperation() && handleEditable()" @click="handleUpdateStep('personRegInfoRsp')">{{t('auth.company.overview.content.text_1')}}</div>
          </div>
          <div class="content-wrap">
            <!--审核状态-->
            <reg-status :checkStatus="formReq.personRegInfoRsp.regCheckStatus" :rejectRemark="formReq.personRegInfoRsp.regRejectRemark" />

            <el-form-item prop="compName" :label="t('auth.personal.register.label.text_1')">
              <span>{{t('auth.personal.register.label.text_1_1')}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.register.label.text_2')">
              <span>{{formReq.personRegInfoRsp.regName}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.register.label.text_3')">
              <span>{{formReq.personRegInfoRsp.regEname}}</span>
            </el-form-item>

            <!--证件签发地-->
            <el-form-item :label="t('auth.company.register.label.country')">
              <span>{{compRegRegionEnum[formReq.personRegInfoRsp.countryCode]||'/'}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.register.label.text_4')">
              <div class="auth-upload-container">
                <div class="upload-title-wrap">
                    <div class="title" style="margin-bottom: 16px;height:40px;line-height: 40px;">{{idTypeEnum[formReq.personRegInfoRsp.idType]}}</div>
                  </div>
                <div class="auth-upload-wrap">
                  <div class="auth-upload">
                    <sr-upload v-model:fileId="formReq.personRegInfoRsp.frontFileId" :filePrefix="FILE.PREFIX.FRONT_FILE" :mode="FILE.UPLOAD_MODE.VIEW"/>

                    <div class="h3 ta-c" v-if="formReq.personRegInfoRsp.idType==='P'">{{t('auth.company.info.content.text_24')}}</div>
                    <div class="h3 ta-c" v-else>{{t('auth.company.register.placeholder.text_6')}}</div>
                  </div>
                  <div class="auth-upload" v-if="formReq.personRegInfoRsp.idType!=='P'" >
                    <sr-upload v-model:fileId="formReq.personRegInfoRsp.backFileId" :filePrefix="FILE.PREFIX.BACK_FILE" :mode="FILE.UPLOAD_MODE.VIEW"/>
                    <div class="h3 ta-c">{{t('auth.company.register.placeholder.text_7')}}</div>
                  </div>
                  <div class="auth-upload" v-if="formReq.personRegInfoRsp.idType!=='P'" >
                    <sr-upload v-model:fileId="formReq.personRegInfoRsp.holdFileId" :filePrefix="FILE.PREFIX.BACK_FILE" :mode="FILE.UPLOAD_MODE.VIEW"/>
                    <div class="h3 ta-c">{{t('auth.company.overview.content.text_5')}}</div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item :label="t('auth.personal.register.label.text_5')">
              <span>{{formReq.personRegInfoRsp.regAddress}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.register.label.text_6')">
              <span>{{formReq.personRegInfoRsp.regEAddress}}</span>
            </el-form-item>
          </div>

          <!--业务信息-->
          <div class="form-operation-wrap">
            <div class="title">{{t('auth.company.business.title.text_1')}}</div>
            <div class="btn" v-if="+stepComplete!==1 && handleEditable()" @click="handleUpdateStep('businessInfoRsp')">{{t('auth.company.overview.content.text_1')}}</div>
          </div>
          <div class="content-wrap">
            <!--审核状态-->
            <!--<reg-status :scopeData="formReq.businessInfoRsp" />-->

            <el-form-item prop="compName" :label="t('auth.personal.business.label.text_4')">
              <span>{{formReq.businessInfoRsp.employmentInfo}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.business.label.text_2')">
              <span>{{formReq.businessInfoRsp.recoCustomerInfo}}</span>
            </el-form-item>

            <el-form-item :label="t('auth.personal.business.label.text_5')">
              <div class="auth-upload-container">
                <div class="h2" style="height: 10px;" ></div>
                <div class="auth-upload-wrap">
                  <div class="auth-upload">
                    <sr-upload v-model:fileId="formReq.businessInfoRsp.otherMaterialFileId" :filePrefix="FILE.PREFIX.OTHER_MATERIAL" :mode="FILE.UPLOAD_MODE.VIEW"/>
                    <div class="h3 ta-c">{{t('auth.company.business.placeholder.text_1')}}</div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <div class="submit" @click="handleSubmitAll">{{handleShowOperation()?t('auth.company.overview.content.text_2'):t('auth.company.overview.content.text_4')}}</div>
    <reset-auth-type-dialog :viewVisible="dialogVisible" @close="dialogVisible = false"/>
  </div>
</template>

<style scoped lang="scss">
  .company-auth-overview-container {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 200px;
    position: relative;

    .reject-wrap {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-radius: 4px;
      font-size: 14px;
      color: #E15C46;
      letter-spacing: 0;
      line-height: 26px;
      background: #FFF3F3;
      margin-bottom: 30px;

      .icon {
        font-size: 20px;
      }
    }

    .content-wrap {
      width: 100%;
      box-sizing: border-box;
      padding-left: 21px;

      span {
        word-break: break-all;
      }

      .card-container {
        width: 100%;

        .title {
          font-size: 14px;
          font-weight: 400;
          color: #677280;
          line-height: 21px;
          margin-bottom: 16px;
        }
      }
    }

    .submit {
      /*position: fixed;*/
      width: 272px;
      height: 48px;
      background: linear-gradient(327deg, #39B7FF 0%, #409EFF 100%);
      box-shadow: 0 13px 44px 12px rgba(64, 158, 255, 0.26);
      border-radius: 6px;
      /*bottom: 82px;*/
      /*left: 50%;*/
      /*transform: translateX(-50%);*/
      margin: 70px auto;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .auth-upload-container {
      width: 100%;

      .upload-title-wrap {
        width: 100%;
      }

      .auth-upload-wrap {
        display: flex;

        .auth-upload {
          margin-right: 60px;
        }
      }
    }

    .form-operation-wrap {
      width: 100%;
      padding: 13px 20px;
      background: linear-gradient(270deg, rgba(237, 245, 253, 0) 0%, rgba(233, 236, 238, 0.58) 100%);
      font-size: 16px;
      font-weight: 600;
      color: #002D4F;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 40px;

      .btn {
        padding: 8px 17px;
        background: #E0EFFF;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #409EFF;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }

    .block-one {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 40px 0;
    }

    .ta-c {
      text-align: center;
    }
  }
</style>
